module.exports = __webpack_public_path__ + "static/img/menu2.6174e20d.png";